import { useMemo } from 'react';
import { cn } from '../../utils';
import { AvatarSize, Email } from './Avatar';

type UserInitialProps = {
    from: Email;
    show?: boolean;
    size?: AvatarSize;
};

export default function UserInitial({
    from,
    show = false,
    size = 'md',
    ...rest
}: UserInitialProps) {
    const initials = useMemo(() => getInitialsFrom(from), [from]);
    return (
        <div
            {...rest}
            className={cn(
                'alli-relative alli-flex alli-place-content-center alli-items-center alli-rounded-full alli-bg-blue-500 alli-font-medium alli-text-white alli-ring-1 alli-ring-blue-500 hover:alli-bg-blue-600 focus:alli-outline-none focus-visible:alli-ring-2 active:alli-bg-blue-800',
                {
                    'alli-bg-blue-800': show,
                    'alli-h-6 alli-w-6 alli-text-xs': size === 'sm',
                    'alli-h-8 alli-w-8 alli-text-sm': size === 'md',
                    'alli-h-10 alli-w-10 alli-text-base': size === 'lg',
                    'alli-h-12 alli-w-12 alli-text-base': size === 'xl',
                },
            )}>
            {initials}
        </div>
    );
}

export function getInitialsFrom(from: Email) {
    const firstPartOfEmail = from?.split('@')?.shift();
    const splitOnPeriod = firstPartOfEmail?.split('.');

    const first = splitOnPeriod?.shift()?.split('')?.shift()?.toUpperCase();

    if (splitOnPeriod && splitOnPeriod.length === 0) return first;

    let last = null;
    if (splitOnPeriod && splitOnPeriod.length >= 1) {
        last = splitOnPeriod?.pop();
    }

    return `${first}${last && last?.split('')?.shift()?.toUpperCase()}`;
}
